import React, { useState, useEffect } from 'react'
import './styles.less'
import ProjectProposalWidget from '../../widgets/projectProposal/ProjectProposalWidget'
import TopLevelNav from '../../components/TopLevelNav'
import PageToolbar from '../../components/PageToolbar'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../utils/loading'
import { getProjectTemplate } from '../../redux/actions/projectTemplate'
import { Grid } from 'rsuite'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'

export default function SelectProposalForm() {
  const [isLoading, setIsLoading] = useState(false)
  const [schema, setSchema] = useState()
  const [error, setError] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const _schema = await getProjectTemplate()
      setSchema(_schema)
    } catch (e) {
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <Grid className="page-home">
      <TopLevelNav />
      <PageToolbar />

      {error ? (
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      ) : (
        <>
          {!schema || isLoading ? (
            <PanalLoadingTemplate />
          ) : (
            <>
              <ContentHeader header={schema.header} subHeader={schema.subHeader} />
              <ProjectProposalWidget schema={schema?.forms?.items} />
            </>
          )}
        </>
      )}
    </Grid>
  )
}
